<script setup lang="ts">
import { cn } from '@/lib/utils'
import { Primitive, type PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { type ButtonVariants, buttonVariants } from '.'

interface Props extends PrimitiveProps {
    variant?: ButtonVariants['variant']
    size?: ButtonVariants['size']
    class?: HTMLAttributes['class']
    direction?: 'back' | 'forward'
}

const props = withDefaults(defineProps<Props>(), {
    as: 'button',
    direction: 'forward',
})
</script>

<template>
    <Primitive
        data-slot="button"
        :as="as"
        :as-child="asChild"
        :class="cn(buttonVariants({ variant, size }), props.class)"
    >
        <template v-if="direction === 'back'">&lt; </template>
        <slot />
        <template v-if="direction === 'forward'"> &gt;</template>
    </Primitive>
</template>
